<template>
  <div :style="{ marginLeft: '0'}">
    <div style="font-size: large;font-weight: bold;zIndex:1">
      .
    </div>
    <iframe
      width="100%"
      height="1200"
      seamless
      frameBorder="0"
      scrolling="no"
      :src="agvReceiptDetails"
      :style="{ marginTop: '-200px',zIndex:0}"
    >
    </iframe>

  </div>
</template>

<script>
  import api from '@/api/index'
  export default {
    name: 'ReceiptDetails',
    data () {
      return {
        agvReceiptDetails:api.BIServerUrl + api.BIAgvReceiptDetails
      }
    },
    created () {
    },
    methods: {
    }
  }
</script>

<style lang="less" scoped>
  .extra-wrapper {
    line-height: 55px;
    padding-right: 24px;

    .extra-item {
      display: inline-block;
      margin-right: 24px;

      a {
        margin-left: 24px;
      }
    }
  }

  .antd-pro-pages-dashboard-analysis-twoColLayout {
    position: relative;
    display: flex;
    display: block;
    flex-flow: row wrap;

    &.desktop div[class^=ant-col]:last-child {
      position: absolute;
      right: 0;
      height: 100%;
    }
  }

  .antd-pro-pages-dashboard-analysis-salesCard {
    height: calc(50% - 12px);
    /deep/ .ant-card-head {
      position: relative;
    }
  }

  .dashboard-analysis-iconGroup {
    i {
      margin-left: 16px;
      color: rgba(0,0,0,.45);
      cursor: pointer;
      transition: color .32s;
      color: black;
    }
  }
  .analysis-salesTypeRadio {
    position: absolute;
    right: 54px;
    bottom: 12px;
  }
</style>
